import { useQuery } from "@apollo/client";
import { Spinner } from "evergreen-ui";
import React from "react";
import Message from "src/Message";
import { GET_CASH_PENDING } from "src/Queries/users.shared";
import { getDateWithTime } from "src/utilities";
import styled from "styled-components";
import RecordRow from "../RecordRow";

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-bottom: 20vh;
`;

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 50vh;
`;

interface IProps {
  id: string;
}
const CashPending: React.SFC<IProps> = ({ id }) => {
  const { data, loading, error } = useQuery(GET_CASH_PENDING, {
    variables: {
      id,
    },
    fetchPolicy: "network-only",
  });

  return (
    <Container>
      {loading && (
        <LoadingWrapper>
          <Spinner />
        </LoadingWrapper>
      )}
      {!loading && error && <Message label={error.message} />}
      {!loading &&
        data &&
        data.cash_balance &&
        (data.cash_balance.length > 0 ? (
          data.cash_balance.map((bal, index) => (
            <RecordRow
              key={index}
              status={bal.status}
              date={getDateWithTime(bal.created_at)}
              item={bal.description}
              figure={
                bal.amount >= 0
                  ? "+ " + Math.abs(bal.amount)
                  : "- " + Math.abs(bal.amount)
              }
            />
          ))
        ) : (
          <Message label="No record found" />
        ))}
    </Container>
  );
};

export default CashPending;
